import { render } from "./NewBookings.vue?vue&type=template&id=2ea859af&ts=true"
import script from "./NewBookings.vue?vue&type=script&lang=ts"
export * from "./NewBookings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__